const Button = ({
  children,
  variant = 'primary',
  className,
  isLoading,
  disabled,
  loadMessage,
  ...props
}) => {
  const bgClass = () => {
    switch (variant) {
      case 'primary':
        return isLoading
          ? 'bg-[#F79009]/[.4] transition-colors duration-200 ease text-white'
          : disabled
            ? 'bg-[#E4E4E7]/[.4] text-[#A1A1AA] border border-gray-300'
            : 'bg-[#F79009] hover:bg-primary-button-hover text-white'
      case 'static':
        return isLoading
          ? 'bg-[#F79009]/[.4] transition-colors duration-200 ease text-white'
          : disabled
            ? 'bg-[#E4E4E7]/[.4] text-[#A1A1AA] border border-gray-300'
            : 'bg-[#F79009] hover:bg-primary-button-hover text-white'
      case 'secondary':
        return disabled || isLoading
          ? 'border-[#F79009]/[.4] transition-colors duration-200 ease text-[#F79009]/[.4]'
          : '!border border-[#F79009] !text-[#F79009] !bg-[#F4F4F5]'
      case 'error':
        return disabled || isLoading
          ? 'bg-error-500/[.4] transition-colors duration-200 ease'
          : 'bg-error-500 text-white'
      case 'red':
        return disabled || isLoading
          ? 'bg-[#EF4343]/[.4] transition-colors duration-200 ease'
          : 'bg-[#EF4343] hover:bg-[#ae0f0f]'
      case 'success':
        return disabled || isLoading
          ? 'bg-success-200/[.4] text-white'
          : 'bg-success-200 text-white'
      default:
        return ''
    }
  }

  return (
    <button
      className={`px-[18px] py-[10px] rounded-lg font-medium transition-colors duration-200 ease ${bgClass()} ${className} ${isLoading || disabled ? 'cursor-not-allowed' : ''} `}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        loadMessage ? (
          <span className="  !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
            {loadMessage}...
          </span>
        ) : (
          <div
            className="inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] animate-spinInfinite"
            role="status"
          >
            <span className="absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
        )
      ) : (
        children
      )}
    </button>
  )
}

export default Button
